<template>
  <MenuList>
    <MenuListItem icon="Move" @click="handleMoveClick"> Move </MenuListItem>
  </MenuList>
</template>

<script setup lang="ts">
import type { Item } from '@/shared/graphql/router/graphql'
import { useDialog } from '@/shared/dialogs/useDialog'
import { Dialogs } from '@/shared/dialogs/types'
import { MenuList, MenuListItem } from '@/shared/components/Menu'

const props = defineProps<{
  items: Item[]
}>()
const emit = defineEmits<{
  clicked: []
}>()

const { open } = useDialog()

const handleMoveClick = () => {
  open(Dialogs.MoveItems, {
    props: { ids: props.items.map((item) => item.id) },
  })
  emit('clicked')
}
</script>
